import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { Box } from '@wix/design-system';
import SaleIcon from '../../../assets/images/new-icon-present.svg';
import { LastDaySaleBannerContent } from './LastDaySaleBannerContent';
import s from './SaleBanner.scss';
import { SaleBannerContent } from './SaleBannerContent';
import { ResellerSaleBannerContent } from './ResellerSaleBannerContent';

interface SaleBannerProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerComp: React.FunctionComponent<SaleBannerProps> = ({
  rootStore,
}) => {
  const { purchaseMode } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();

  const renderSaleBannerContent = () => {
    if (
      rootStore.appStore.isResellerOffering &&
      rootStore.appStore.resellerOfferingBrandingInfo?.name
    ) {
      return <ResellerSaleBannerContent />;
    }
    if (purchaseMode === PurchaseMode.LAST_DAY_SALE) {
      return <LastDaySaleBannerContent />;
    }
    return <SaleBannerContent />;
  };

  return (
    <Box className={classNames(s.saleStrip, theme)} dataHook='sale-banner'>
      <Box className={classNames(s.saleIcon)}>
        <SaleIcon />
      </Box>
      <Box padding='13px 36px 13px 0' verticalAlign='middle'>
        {renderSaleBannerContent()}
      </Box>
    </Box>
  );
};

export const SaleBanner = withInjectedRootStore(
  withExperiments(SaleBannerComp),
);
